export const faqs = [
  {
    q: "¿Necesito experiencia vendiendo?",
    a: "No. El material está pensado para quien cocina bien pero nunca vendió. Empieza desde cero y avanza paso a paso.",
  },
  {
    q: "¿Cómo recibo el material?",
    a: "Es un producto 100% digital. Después de completar el pago, recibes por correo electrónico el acceso para descargar los 6 volúmenes y los 4 bonos.",
  },
  {
    q: "¿Puedo leerlo desde el celular?",
    a: "Sí. Los volúmenes están en formato PDF y se leen cómodamente en celular, tablet o computadora.",
  },
  {
    q: "¿Es un pago único o una suscripción?",
    a: "Es un pago único de {precio}. No hay cobros mensuales ni renovaciones automáticas.",
  },
  {
    q: "¿Sirve para mi país?",
    a: "Sí. Está pensado para Latinoamérica: los costos y precios los calculas con tus propios valores y en tu moneda local.",
  },
  {
    q: "¿Necesito tener Excel instalado?",
    a: "La planilla también puede abrirse con Google Sheets, que es gratuito y funciona desde el navegador o el celular.",
  },
  {
    q: "¿Me garantiza que voy a vender en 30 días?",
    a: "No. Ningún material honesto puede prometer eso. Lo que te da es un plan claro y herramientas listas para usar. Los resultados dependen de tu producto, tu zona y la constancia con la que apliques cada paso.",
  },
  {
    q: "¿Qué incluye exactamente la compra?",
    a: "Los 6 volúmenes digitales y los 4 bonos descritos en esta página. Cualquier material adicional se ofrece por separado.",
  },
];
